export const MapKey = 'AIzaSyB3mMuvl8IUlviRZiizBiX7uhsdIqunx94';
export const MapBoxAccessKey =
    'pk.eyJ1IjoiaHNuY29vbDgiLCJhIjoiY2s5dHRnbGRwMGN5ZTNsbnliNzl0ZDg5MyJ9.P2AEkILzNEgg9ArpzGVPXw';
